import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import PageSection from '../../../../../features/components/PageSection'

import useStyles from '../styles'

const GraphContainer = ({ title, totalValue, totalValueDescription, children, legendContainerId, className }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <PageSection className={classnames(classes.sectionContainer, className)}>
      <div className={classes.headingContainer}>
        <div className={classes.left}>
          <div className={classes.title}>{t(title)}</div>
          <div className={classes.value}>
            {totalValue}
            {totalValueDescription && <span className={classes.valueDescription}>{' ' + totalValueDescription}</span>}
          </div>
        </div>

        {legendContainerId && (
          <div id={legendContainerId}>{/*// The legend of the graph will be rendered here by the plugin*/}</div>
        )}
      </div>
      {children}
    </PageSection>
  )
}

GraphContainer.propTypes = {
  title: PropTypes.string.isRequired,
  totalValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalValueDescription: PropTypes.string,
  children: PropTypes.node.isRequired,
  legendContainerId: PropTypes.string,
  className: PropTypes.string
}

export default GraphContainer
